import React, { useState } from 'react';
import Sidebar from './Sidebar.js';
import AdminHeader from './Header.js';
import { Card, Row, Col, Container, Button } from 'react-bootstrap';
import Breadcrumb from './Breadcrumb.js';
import studyDirectionsData from './data/studyDirections.js';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const MappingStudyFieldsView = () => {

    const navigate = useNavigate();

    return (
        <>
            <AdminHeader />
            <Container className="pt-2">
                <Row>
                    <Col xs={2} className="p-0">
                    </Col>
                    <Col xs={10} className="p-0">
                        <Breadcrumb />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col xs={3} className="p-0">
                        <Sidebar />
                    </Col>

                    <Col xs={9} className="p-4">
                        <Card>
                            <Card.Body>
                                <h1 className="mb-3">Study fields</h1>
                                <Row className="mb-4">
                                    <Col>
                                        {studyDirectionsData.map((studyDirection, index) => (
                                            <Row>
                                                <Col md={12}>
                                                    <p className="form-control-plaintext">{studyDirection.name}</p>
                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => navigate(`/mapping-study-fields/${index}/subspecialist`)}
                                                    >
                                                        Sub Specialist
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end gap-2 px-4">
                        <Button variant="secondary" onClick={() => navigate('/mapping-overview')}>
                            Back
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MappingStudyFieldsView;
